import Service from '../../services'
import { chartType } from '../../utils/Constants'

// initial state
const state = {
    chartToImage: {
        id: '',
        title: 'graph title',
        caption: 'graph caption',
        chart: {
            labels: [2526, 2530, 2535, 2540],
            label: 'test unit',
            type: chartType.pie
        },
        chartOptions: {
          linecolor: '#1D4E9D', // Line chart exclusive
          pointcolor: '#FF5100', // Line chart exclusive
          barcolor: '#4F4F4F', // Line chart exclusive
          piecolor: [], // Line chart exclusive
          lineTension: 0,
        },
        chartData: [4573, 1500, 32434, 23500],
    }
}

// getters
const getters = {}

// actions
const actions = {
    setChartToImage({ commit }, chart) {
        commit('setChartToImage', chart);
        return 'done';
    },
    uploadChartImage({ state }, { base64, fileName }) {
        return Service.chartdata.uploadChartImage(base64, fileName)
    }
}

// mutations
const mutations = {
    setChartToImage(state, chartToImage) {
        state.chartToImage = chartToImage;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
